<div class="success-modal">
  <h3>Would you like to delete the data generated by the rule?</h3>

  <md-dialog-content>
    <div class="grid">
      <div class="row">
        <span>ALL</span>
        <md-slide-toggle [checked]="allAreSelected()" (change)="switchDeleteAll()"></md-slide-toggle>
        <br />
      </div>
      <div *ngFor="let magicBoxRuleShort of magicBoxRuleShorts" class="row">
        <span>{{magicBoxRuleShort.language.value}}</span>
        <md-slide-toggle [checked]="magicBoxRuleShort.toDelete" [(ngModel)]="magicBoxRuleShort.toDelete">
        </md-slide-toggle>
        <br />
      </div>
    </div>
  </md-dialog-content>
  <md-dialog-actions>
    <div class="actions">
      <button md-raised-button color="warn" (click)="delete()">
        <md-icon>delete</md-icon>
        Delete selected items
      </button>
    </div>
  </md-dialog-actions>
</div>


// WEBPACK FOOTER //
// ./src/app/modals/delete-generated-fields/delete-generated-fields.component.html